import { EMPTY_STRING } from '@assetron/common/constants/constant';
import {
  PENDING_CREDENTIAL,
  PENDING_CREDENTIAL_EMAIL,
} from '@assetron/web-common/constants/LocalStorageConstants';
import { FirebaseError } from 'firebase/app';
import { OAuthProvider } from 'firebase/auth';

const handleAccountExistsWithDifferentCredError = (
  error: FirebaseError,
): void => {
  const pendingCred = OAuthProvider.credentialFromError(error);

  window.sessionStorage.setItem(
    PENDING_CREDENTIAL,
    JSON.stringify(pendingCred?.toJSON()),
  );

  window.sessionStorage.setItem(
    PENDING_CREDENTIAL_EMAIL,
    error?.customData?.email ?? EMPTY_STRING,
  );
};

export default handleAccountExistsWithDifferentCredError;
